import {
	ExportFlow,
	ExportFlowPayload,
	FlowImportParameters,
	FlowImportPayload,
	GetFlowParameterPayload,
	GetFlowParameters,
	ImportExportConfig,
	ImportFlow,
	UnlinkFile,
} from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';
import {
	buildURL,
	handleResponse,
	isURLSet,
	standardGet,
	standardPost,
} from '../classes/http-helper-const';
import QueryParameter from '../classes/query-parameter';

export class FlowImportExportHttpService extends CRUDHelperBase<ImportExportConfig> {
	constructor() {
		super(ImportExportConfig.name);
	}

	async export(exportFlowPayload: ExportFlowPayload) {
		isURLSet();
		const url = buildURL(this.objectType, [ExportFlow]);
		const response = await standardPost(url, exportFlowPayload);
		return response;
	}

	async getFlowParameters(
		getFlowParameterPayload: GetFlowParameterPayload,
		options?: {
			success?: (response?: FlowImportParameters[]) => void | Promise<void>;
			error?: (data: any) => void | Promise<void>;
		}
	) {
		isURLSet();
		const url = buildURL(this.objectType, [GetFlowParameters]);
		const response = await standardPost(url, getFlowParameterPayload);
		await handleResponse(response, 'Get Flow Parameters', this.objectType, options);
	}

	async importFlow(
		flowImportPayload: FlowImportPayload,
		options?: {
			success?: (response?: any) => void | Promise<void>;
			error?: (data: any) => void | Promise<void>;
		}
	) {
		isURLSet();
		const url = buildURL(this.objectType, [ImportFlow]);
		const response = await standardPost(url, flowImportPayload);
		await handleResponse(response, 'Import Flow', this.objectType, options);
	}

	async unlinkFile(fileID: string) {
		isURLSet();
		const url = buildURL(this.objectType, [UnlinkFile], [new QueryParameter('fileID', fileID)]);
		const response = await standardGet(url);
		await handleResponse(response, 'Unlink File', this.objectType);
	}
}
